import { compose, withState, withPropsOnChange } from 'react-recompose';
//////////////////////////////////////////////////

export const withRerenderComponent = (propsToCheck) => compose(
  withState('showComponent', 'setShowComponent', true),
  withPropsOnChange(
    propsToCheck,
    (props) => {
      props.setShowComponent(false);
      setTimeout(() => {
        props.setShowComponent(true);
      }, 0);
    },
  ),
);
